/**
 * Date-extensions locale Hungarian [hu]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('hu', {
    monthNames: ['Január','Február','Március','április','Május','Június','Július','Augusztus','Szeptember','Október','November','December'],
    monthShortNames: ['Jan','Feb','Márc','ápr','Máj','Jún','Júl','Aug','Szept','Okt','Nov','Dec'],
    dayNames: ['Vasárnap','Hétfő','Kedd','Szerda','Csütörtök','Péntek','Szombat'],
    dayShortNames: ['Vas','Hét','Kedd','Sze','Csüt','Pén','Szo']
});
